/* eslint-disable no-useless-escape */
import * as yup from 'yup';

export interface YupFieldProps {
  value: string;
  originalValue: string;
  label: string;
  path: string;
}

export const isEmail = yup.string().test(
  'isEmail',
  (props: YupFieldProps) => ({
    tag: 'YUP_VALIDATION_NOT_EMAIL_ERROR',
    values: props
  }),
  value => {
    if (!value) return true;
    const expression =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return expression.test(value);
  }
);

export const isUrl = yup.string().test(
  'isUrl',
  (props: YupFieldProps) => ({
    tag: 'YUP_VALIDATION_NOT_URL_ERROR',
    values: props
  }),
  value => {
    if (!value) return true;
    const expression = /^(http|https):\/\/[^ "]+$/;
    return expression.test(value);
  }
);
